var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-svg",class:{ loaded: !_vm.isShow }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("@/assets/ssoauth/loading.svg"),"alt":""}}),_c('p',[_vm._v("Loading")])])
}]

export { render, staticRenderFns }